
interface Props {
  backIcon?: boolean;
  name?: string;
  price?: string;
  image?: string;
  size?: 'medium' | 'large';
}
const __sfc_main = {};
__sfc_main.props = {
  backIcon: {
    key: "backIcon",
    required: false,
    type: Boolean,
    default: false
  },
  name: {
    key: "name",
    required: false,
    type: String,
    default: '-'
  },
  price: {
    key: "price",
    required: false,
    type: String,
    default: '-'
  },
  image: {
    key: "image",
    required: false,
    type: String
  },
  size: {
    key: "size",
    required: false,
    type: String,
    default: 'medium'
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const emit = __ctx.emit;
  return {
    emit
  };
};
export default __sfc_main;
